/**
 * PII (Personal Information) reveal — frontend permission slug constants.
 *
 * These mirror the backend RBAC slugs seeded in
 * `MyAMSBackend/utils/permissionSeeds.js` (module `pii`). Keep them in sync with
 * the backend; route guards (`PermissionBasedRoute`) and conditional rendering
 * of the unmask (eye) control reference these constants rather than hard-coded
 * strings.
 *
 * Reference: .kiro/specs/pii-masking/design.md (§9) and requirements 8.5, 9.x.
 */

export const PII_PERMISSIONS = {
  // Full student PII reveal (hod / admin / institute / superAdmin), audited.
  STUDENT_REVEAL: "student.pii.reveal",
  // Full teacher PII reveal (hod / admin / institute / superAdmin), audited.
  TEACHER_REVEAL: "teacher.pii.reveal",
  // Mentee parent-contact-only reveal for GFM teachers, audited.
  STUDENT_REVEAL_MENTEE: "student.pii.reveal_mentee",
  // Full user PII reveal (admin / superAdmin), audited.
  USER_REVEAL: "user.pii.reveal",
};

export default PII_PERMISSIONS;
